// hello ashok
import React, { useEffect, useRef, useState } from "react";
import banner from "../assets/warranty registration-01.png";
import banner2 from "../assets/warrenty2.png";
import success from "../assets/verificationSuccess.jpg";
import verified from "../assets/alreadyVerified.jpg";
import failed from "../assets/verificationFailed.jpg";
import { getImage, warrantyDetails, warrantyExtend } from "../services/Tools";
import { showSnackbar } from "../comopnents/snackbar";
import "../styles/warranty.css";
import { VerifyScratchCard } from "../services/Cart";
import { getProductById } from "../services/apiService";
import AuthModal from "../comopnents/AuthModal";
import { useNavigate } from "react-router-dom";

const Warranty = () => {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isInvoiceUploading, setIsInvoiceUploading] = useState(false);
  const [isProductUploading, setIsProductUploading] = useState(false);
  const [responseInvoiceFile, setResponseInvoiceFile] = useState("");
  const [responseProductFile, setResponseProductFile] = useState("");
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [models, setModels] = useState([]);
  const [errors, setErrors] = useState({});
  const [productid, setProductId] = useState(null);
  const [isScratchVerified, setIsScratchVerified] = useState(false);
  const [scratchStatus, setScratchStatus] = useState(null); // null | 'success' | 'error'
  const [scratchErrorMsg, setScratchErrorMsg] = useState("");
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const [verifiedProduct, setVerifiedProduct] = useState(null);
  const serialManuallyEdited = useRef(false);
  const navigate = useNavigate();

  const scrollToProductTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetScratch = () => {
    setScratchStatus(null);
    setIsScratchVerified(false);
    setScratchErrorMsg("");
    setForm((prev) => ({ ...prev, scratchNumber: "" }));
    setVerifiedProduct(null);
    setProduct(null);
    setProductId(null);
    setShowForm(false);
    serialManuallyEdited.current = false;
  };

  const [form, setForm] = useState({
    userid: localStorage.getItem("userId") || "",
    orderno: "",
    name: localStorage.getItem("userName") || "",
    email: "",
    mobile: localStorage.getItem("mobile") || "",
    dealername: "",
    dealerstate: "",
    dealercity: "",
    sku: "",
    modelno: "",
    category: "",
    brand: "",
    invoiceimage: "",
    productid: verifiedProduct?.productid,
    productimage: "",
    startdate: new Date().toISOString().split("T")[0],
    enddate: "",
    warrantytype: "",
    scratchNumber: "",
    serialnumber: verifiedProduct?.hologram_number || "",
  });

  useEffect(() => {
    if (verifiedProduct?.hologram_number && !serialManuallyEdited.current) {
      setForm((prev) => ({
        ...prev,
        serialnumber: verifiedProduct.hologram_number,
      }));
    }
  }, [verifiedProduct]);

  // Get today's date for max attribute
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    console.log(
      "🔧 Warranty Page Loaded - User ID:",
      localStorage.getItem("userId"),
    );
    fetchWarrantyDetails();
  }, []);

  const submitScratchNumber = async () => {
    const userid = localStorage.getItem("userId");
    const mobileno = localStorage.getItem("mobile");
    if (!userid) {
      setShowAuthModal(true);
      return;
    }
    if (!form.scratchNumber.trim()) {
      showSnackbar("error", "Please enter a scratch number");
      return;
    }
    try {
      const response = await VerifyScratchCard({
        scratchNumber: form.scratchNumber,
        userid,
        mobileno,
      });
      setVerifiedProduct(response);
      if (response?.productid === -444) {
        const alreadyVerifiedMsg =
          "This product has already been verified. Please ensure you have entered the correct hologram number, then try again.";
        if (response.msg === alreadyVerifiedMsg) {
          navigate("/alreadyverified", {
            state: {
              scratchNumber: form.scratchNumber,
            },
          });
          setScratchStatus("already_verified");
          setScratchErrorMsg(response.msg);
        } else {
          setScratchStatus("error");
          navigate("/invalidproduct", {
            state: {
              scratchNumber: form.scratchNumber,
            },
          });
          setScratchErrorMsg(response.msg || "Invalid scratch number");
          showSnackbar("error", response.msg || "Invalid scratch number");
        }
      } else {
        setScratchStatus("success");
        showSnackbar(
          "success",
          response.msg || "Scratch number verified successfully",
        );
        // Pass full verified product data including warranty info
        navigate("/verificationSuccess", {
          state: { verifiedProduct: response },
        });

        setScratchErrorMsg(
          response.msg || "Scratch number verified successfully",
        );
        setIsScratchVerified(true);
        setVerifiedProduct(response);
        setProductId(response.productid);
        if (response.warrent_type?.length) {
          const types = response.warrent_type.map((t) => ({ warrantytype: t }));
          setSubCategories(types);
          setForm((prev) => ({ ...prev, warrantytype: types[0].warrantytype }));
        }
      }
    } catch (error) {
      setScratchStatus("error");
      setScratchErrorMsg("Failed to submit scratch number");
      showSnackbar("error", "Failed to submit scratch number");
      console.log(error);
    }
  };
  useEffect(() => {
    if (!productid) return;
    setLoading(true);
    getProductById(productid)
      .then((res) => {
        const p = { ...res.data[0], qty: 0 };
        setProduct(p);
        setMainImage(p.image1);

        // Scroll to top when product loads
        setTimeout(scrollToProductTop, 100);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
        setLoading(false);
      });
  }, [productid]);

  const fetchWarrantyDetails = async () => {
    setLoading(true);
    console.log("📡 Fetching warranty details...");
    try {
      const data = await warrantyDetails();
      console.log("✅ Warranty Details API Response:", data);
      setItems(data);
    } catch (error) {
      console.error("❌ Warranty details error:", error);
      showSnackbar("error", "Failed to load warranty details.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + parseInt(days || 0));
    return result;
  };

  const validate = () => {
    const newErrors = {};
    if (!form.orderno) newErrors.orderno = "Invoice No is required";
    if (!form.serialnumber)
      newErrors.serialnumber = "Serial Number is required";
    // if (!form.name) newErrors.name = "Name is required";
    // if (!form.email) newErrors.email = "Email is required";
    // if (!form.mobile) newErrors.mobile = "Mobile No is required";
    if (!form.dealername) newErrors.dealername = "Dealer Code is required";
    if (!form.startdate) newErrors.startdate = "Invoice Date is required";
    if (!responseInvoiceFile)
      newErrors.invoiceimage = "Invoice image is required";
    if (!responseProductFile)
      newErrors.productimage = "Warranty card image is required";
    return newErrors;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    if (name === "scratchNumber") {
      setScratchStatus(null);
      setScratchErrorMsg("");
    }
    if (name === "serialnumber") {
      serialManuallyEdited.current = true;
    }
  };

  const uploadImage = async ({ image, filePath, field }) => {
    if (field === "invoiceimage") {
      setIsInvoiceUploading(true);
    } else {
      setIsProductUploading(true);
    }

    console.log(`📤 Uploading ${field}:`, filePath);

    try {
      const filename = filePath.split("/").pop();
      const uploadResponse = await getImage({
        filename,
        image,
        userid: form.userid,
        processes: "warranty",
      });

      console.log(`📥 ${field} Upload API Response:`, uploadResponse);

      const imageUrl =
        uploadResponse?.image ||
        uploadResponse?.data?.imageurl ||
        uploadResponse?.imageurl ||
        uploadResponse?.url;

      if (imageUrl) {
        console.log(`✅ ${field} Image URL extracted:`, imageUrl);
        if (field === "invoiceimage") {
          setResponseInvoiceFile(imageUrl);
          setForm((prev) => ({ ...prev, invoiceimage: imageUrl }));
        } else if (field === "productimage") {
          setResponseProductFile(imageUrl);
          setForm((prev) => ({ ...prev, productimage: imageUrl }));
        }
        return imageUrl;
      } else {
        console.warn(
          "❌ Upload Failed - No image URL found:",
          uploadResponse?.error || uploadResponse,
        );
        showSnackbar("error", "Image upload failed.");
        return null;
      }
    } catch (error) {
      console.error(
        `❌ ${field} Upload Error:`,
        error?.response?.data || error?.message || error,
      );
      showSnackbar("error", "Image upload failed.");
      return null;
    } finally {
      if (field === "invoiceimage") {
        setIsInvoiceUploading(false);
      } else {
        setIsProductUploading(false);
      }
    }
  };

  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
  ];

  const handleFileUpload = async (event, field) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file size (max 2MB)
    if (file.size > 2 * 1024 * 1024) {
      showSnackbar("error", "File size should be less than 2MB");
      return;
    }

    // Validate file type
    if (!allowedTypes.includes(file.type)) {
      showSnackbar("error", "Please upload a JPG, JPEG, PNG, or PDF file");
      return;
    }
    console.log(
      `📁 File selected for ${field}:`,
      file.name,
      `(${(file.size / 1024).toFixed(2)} KB)`,
    );

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64 = reader.result;
      await uploadImage({
        image: base64,
        filePath: file.name,
        field,
      });
    };
    reader.readAsDataURL(file);
  };

  const submitWarranty = async (event) => {
    event.preventDefault();

    // Validate form
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      showSnackbar("error", "Please fill all required fields");
      return;
    }

    setSubmitting(true);

    // Calculate end date (start date + 365 days warranty)
    const startDateObj = new Date(form.startdate);
    const warrantyDays = 365; // Default 1 year
    const endDate = formatDate(addDays(startDateObj, warrantyDays));

    const payload = {
      userid: form.userid,
      orderno: form.orderno,
      serialnumber: form.serialnumber,
      invoiceimage: responseInvoiceFile,
      productimage: responseProductFile,
      dealername: form.dealername,

      productid: verifiedProduct?.productid,
      category: verifiedProduct?.category,
      modelno: verifiedProduct?.modelno,
      startdate: form.startdate,
      scratchno: verifiedProduct?.hologram_number,
    };

    console.log("📋 Warranty Extension Payload:", payload);

    try {
      const response = await warrantyExtend(payload);
      console.log("✅ Warranty Extension API Response:", response);

      if (response?.status === 200 || response?.success) {
        console.log("✅ Warranty successfully registered!");

        navigate("/warrantysucess");

        // Reset form
        setForm({
          userid: form.userid,
          orderno: "",
          name: "",
          email: "",
          mobile: "",
          scratchNumber: "",
          dealername: "",
          dealerstate: "",
          dealercity: "",
          sku: "",
          modelno: "",
          category: "",
          brand: "",
          warrantytype: "",
          serialnumber: "",
          invoiceimage: "",

          productid: "",
          productimage: "",
          startdate: new Date().toISOString().split("T")[0],
          endDate: "",
        });
        setResponseInvoiceFile("");
        setResponseProductFile("");
        setErrors({});
        setShowForm(false);

        setIsScratchVerified(false);
        setScratchStatus(null);
        setProduct(null);
        setProductId(null);
      } else {
        console.warn(
          "⚠️ Warranty submission returned status:",
          response?.status,
          response?.success,
        );
        showSnackbar(
          "error",
          "Something went wrong during warranty submission.",
        );
      }
    } catch (error) {
      console.error("❌ Warranty Extension API Error:", {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      showSnackbar("error", "Failed to submit warranty to the server.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <app-header></app-header>

      <div style={{ position: "relative" }}>
        <img src={banner} alt="banner" className="banner-img" />
      </div>

      <div className="row justify-content-center" style={{ marginTop: "40px" }}>
        <div className={`col-md-8 col-lg-7 scratch-card-wrapper mb-4`}>
          <div
            className={`scratch-card scratch-card-overlap ${isScratchVerified ? "verified" : ""} ${scratchStatus === "error" ? "error" : ""} ${scratchStatus === "already_verified" ? "already-verified" : ""}`}
            style={{ position: "relative" }}
          >
            {(scratchStatus === "already_verified" ||
              scratchStatus === "error") && (
              <button
                type="button"
                onClick={resetScratch}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "12px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#999",
                  cursor: "pointer",
                  lineHeight: 1,
                  padding: "4px 8px",
                  zIndex: 3,
                }}
              >
                ✕
              </button>
            )}
            {/* <div className="scratch-card-left">
              <div className="scratch-card-icon">
                {scratchStatus === "success" ? (
                  <span className="status-icon success">✓</span>
                ) : scratchStatus === "already_verified" ? (
                  <span className="status-icon already-verified">⚠</span>
                ) : scratchStatus === "error" ? (
                  <span className="status-icon error">✕</span>
                ) : (
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#005487"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="9" y1="21" x2="9" y2="9" />
                  </svg>
                )}
              </div>
            </div> */}
            <div className="scratch-card-right">
              {scratchStatus === "success" ? (
                <>
                  <img className="status-img" src={success} alt="Verified" />
                  <h6 className="status-text">{scratchErrorMsg}</h6>
                </>
              ) : scratchStatus === "already_verified" ? (
                <>
                  <img
                    className="status-img"
                    src={verified}
                    alt="Already Verified"
                  />
                  <h6 className="status-text">{scratchErrorMsg}</h6>
                </>
              ) : scratchStatus === "error" ? (
                <>
                  <img
                    className="status-img"
                    src={failed}
                    alt="Verification Failed"
                  />
                  <h6 className="status-text">{scratchErrorMsg}</h6>
                </>
              ) : (
                <>
                  <span className="status-text scratch-label">
                    Verify Scratch Number
                  </span>
                  <div className="scratch-input-group">
                    <input
                      type="text"
                      className="form-control scratch-input"
                      name="scratchNumber"
                      value={form.scratchNumber}
                      onChange={handleChange}
                      placeholder="Enter your Scratch Number"
                    />
                    <button
                      type="button"
                      className="btn btn-primary scratch-btn"
                      onClick={submitScratchNumber}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="scratch-more-info">
                    <video
                      className="warranty-video"
                      controls
                      autoPlay
                      muted
                      playsInline
                      preload="auto"
                    >
                      <source
                        src="https://pixeltools.in/test/products/Warrany_video.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </>
              )}
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <img src={banner2} alt="banner" className="banner-img" />
          </div>
        </div>
      </div>

      <div className="container">
        {isScratchVerified && (
          <>
            <h2 className="text-center fw-bold mb-3">Warranty Registration</h2>
            {/* <p className="text-center text-muted mb-5">
              Extend your warranty to enjoy extra coverage and peace of mind, protecting your purchase
              from unexpected repair costs and ensuring hassle-free service.
            </p> */}
          </>
        )}

        <div className="row justify-content-center">
          {/* Product Details Section - shown after scratch verification */}
          {isScratchVerified && product && (
            <div className="col-md-8 mb-4">
              <div className="product-details-card">
                <div className="product-details-header">
                  <h4>Product Details</h4>
                </div>
                <div className="product-details-body">
                  <div className="product-details-image">
                    <img
                      src={mainImage || product.image1}
                      alt={product.displaymodelno}
                    />
                  </div>
                  <div className="product-details-info">
                    <div className="product-details-row">
                      <span className="detail-label">Model No</span>
                      <span className="detail-value">
                        {product.displaymodelno}
                      </span>
                    </div>
                    <div className="product-details-row">
                      <span className="detail-label">Category</span>
                      <span className="detail-value">{product.category}</span>
                    </div>
                    <div className="product-details-row">
                      <span className="detail-label">Subcategory</span>
                      <span className="detail-value">
                        {product.subcategory}
                      </span>
                    </div>
                    <div className="product-details-row">
                      <span className="detail-label">Brand</span>
                      <span className="detail-value">{product.brand}</span>
                    </div>
                    {/* <div className="product-details-row">
                      <span className="detail-label">MRP</span>
                      <span className="detail-value">₹{Number(product.mrp || 0).toFixed(2)}</span>
                    </div>
                    <div className="product-details-row">
                      <span className="detail-label">Barcode</span>
                      <span className="detail-value">{product.barcode}</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Register Warranty Button - shown after product details */}
          {isScratchVerified && product && !showForm && (
            <div className="col-md-8 mb-4 text-center">
              <button
                type="button"
                className="btn btn-primary btn-register-warranty"
                onClick={() => setShowForm(true)}
              >
                Register Warranty
              </button>
            </div>
          )}

          {/* Warranty Form Section - shown after clicking Register Warranty */}
          {isScratchVerified && showForm && (
            <div className="col-md-8">
              <form onSubmit={submitWarranty} className="warranty-form">
                <h1 className="form-heading">Pixel Tools</h1>
                <div className="form-row">
                  {/* Row 1: Invoice No | Invoice Date */}
                  <div className="form-group">
                    <label className="form-label">
                      Invoice No <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.orderno ? "is-invalid" : ""}`}
                      name="orderno"
                      value={form.orderno}
                      onChange={handleChange}
                      placeholder="Enter invoice number"
                    />
                    {errors.orderno && (
                      <div className="invalid-feedback">{errors.orderno}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Invoice Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      className={`form-control ${errors.startdate ? "is-invalid" : ""}`}
                      name="startdate"
                      value={form.startdate}
                      onChange={handleChange}
                      max={today}
                    />
                    {errors.startdate && (
                      <div className="invalid-feedback">{errors.startdate}</div>
                    )}
                  </div>

                  {/* Row 2: Serial Number | Dealer Code */}
                  <div className="form-group">
                    <label className="form-label">
                      Serial Number <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.serialnumber ? "is-invalid" : ""}`}
                      name="serialnumber"
                      value={form.serialnumber}
                      onChange={handleChange}
                      placeholder="Enter product serial number"
                    />
                    {errors.serialnumber && (
                      <div className="invalid-feedback">
                        {errors.serialnumber}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Dealer Code <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.dealercode ? "is-invalid" : ""}`}
                      name="dealername"
                      value={form.dealername}
                      onChange={handleChange}
                      placeholder="Enter dealer code"
                    />
                    {errors.dealercode && (
                      <div className="invalid-feedback">
                        {errors.dealercode}
                      </div>
                    )}
                  </div>

                  {/* Row 3: Warranty Type (Full Width) */}
                  <div className="form-group form-group-full">
                    <label className="form-label">Warranty Type</label>
                    <input
                      type="text"
                      className="form-control"
                      name="warrantytype"
                      value={form.warrantytype || "N/A"}
                      readOnly
                    />
                  </div>

                  {/* Row 4: Upload Invoice | Upload Warranty Card */}
                  <div className="form-group">
                    <label className="form-label">
                      Upload Invoice (max 2Mb){" "}
                      <span className="required">*</span>
                    </label>
                    <div className="file-input-wrapper">
                      <input
                        type="file"
                        id="invoiceFile"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, "invoiceimage")}
                        disabled={isInvoiceUploading}
                      />
                      <label htmlFor="invoiceFile" className="file-input-label">
                        <span>
                          {form.invoiceimage
                            ? "Invoice uploaded"
                            : "Click to upload invoice image"}
                        </span>
                      </label>
                    </div>
                    {isInvoiceUploading && (
                      <div className="file-uploading">
                        <span className="spinner-border spinner-border-sm"></span>
                        Uploading invoice image...
                      </div>
                    )}
                    {responseInvoiceFile && !isInvoiceUploading && (
                      <div className="file-preview">
                        <div className="file-name">
                          ✓ Invoice image uploaded successfully
                        </div>

                        <img
                          className="preview-img"
                          src={responseInvoiceFile}
                          alt="Invoice"
                        />
                      </div>
                    )}
                    {errors.invoiceimage && (
                      <div className="invalid-feedback">
                        {errors.invoiceimage}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Upload Warranty Card (max 2Mb){" "}
                      <span className="required">*</span>
                    </label>
                    <div className="file-input-wrapper">
                      <input
                        type="file"
                        id="productFile"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, "productimage")}
                        disabled={isProductUploading}
                      />
                      <label htmlFor="productFile" className="file-input-label">
                        <span>
                          {form.productimage
                            ? "Warranty card uploaded"
                            : "Click to upload warranty card"}
                        </span>
                      </label>
                    </div>
                    {isProductUploading && (
                      <div className="file-uploading">
                        <span className="spinner-border spinner-border-sm"></span>
                        Uploading warranty card...
                      </div>
                    )}
                    {responseProductFile && !isProductUploading && (
                      <div className="file-preview">
                        <div className="file-name">
                          ✓ Invoice image uploaded successfully
                        </div>

                        <img
                          className="preview-img"
                          src={responseProductFile}
                          alt="Invoice"
                        />
                      </div>
                    )}
                    {errors.productimage && (
                      <div className="invalid-feedback">
                        {errors.productimage}
                      </div>
                    )}
                  </div>
                </div>
                {/* Terms & Conditions */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="checkbox"
                    id="acceptTerms"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                  />

                  <label htmlFor="acceptTerms" style={{ margin: 0 }}>
                    I agree to the{" "}
                    <span
                      onClick={() => setShowTerms(true)}
                      style={{
                        color: "#0d6efd",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "600",
                      }}
                    >
                      Terms & Conditions
                    </span>
                  </label>
                </div>
                {showTerms && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 9999,
                    }}
                  >
                    <div
                      style={{
                        width: "90%",
                        maxWidth: "700px",
                        background: "#fff",
                        borderRadius: "10px",
                        padding: "25px",
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      <h3>Terms & Conditions</h3>

                      <div style={{ marginTop: "15px" }}>
                        <p>
                          The following terms and conditions apply to all
                          warranty claims for Pixel Tools products. Please read
                          them carefully before submitting your warranty
                          request.
                        </p>

                        <ol
                          style={{
                            paddingLeft: "20px",
                            lineHeight: "1.8",
                            color: "#444",
                            fontSize: "15px",
                          }}
                        >
                          <li>
                            Valid Purchase Invoice — A valid purchase invoice is
                            mandatory for all warranty claims. The original
                            invoice serves as proof of purchase and must be
                            presented at the time of claiming warranty.
                          </li>
                          <li>
                            Warranty Card — The warranty card must be completely
                            filled with accurate customer details, product
                            details, seller details, and the seller's official
                            seal. Incomplete or incorrect warranty cards may
                            lead to rejection of the warranty claim.
                          </li>
                          <li>
                            Warranty Product Registration — The product must be
                            registered on the Pixel Tools website using a valid
                            dealer code. Registration is mandatory to activate
                            the product warranty.
                          </li>
                          <li>
                            Correct Information — All information provided
                            during warranty registration must be accurate and
                            complete. Any incorrect or false information may
                            result in cancellation of the warranty.
                          </li>
                          <li>
                            Warranty Verification — Warranty will be activated
                            only after successful verification of the product
                            details registered on the Pixel Tools website.
                            Verification ensures the authenticity of the product
                            and the validity of the warranty.
                          </li>
                          <li>
                            Required Documents — All documents submitted during
                            the warranty registration process must be clear,
                            complete, and readable. Unclear or incomplete
                            documents may delay the registration process.
                          </li>
                          <li>
                            Warranty Period — The warranty is valid only for the
                            period specified for the product. Claims submitted
                            after the warranty period has expired will not be
                            accepted.
                          </li>
                          <li>
                            Warranty Start Date — The warranty period starts
                            from the purchase date mentioned on the original
                            invoice. Customers are advised to keep the invoice
                            safe for future reference.
                          </li>
                          <li>
                            Normal Operating Conditions — Warranty is applicable
                            only when the product is used under normal operating
                            conditions. Damage caused by abnormal usage or
                            improper operation is not covered under warranty.
                          </li>
                          <li>
                            Manufacturing Defects — The warranty covers only
                            manufacturing defects confirmed by Pixel Tools. It
                            does not cover issues caused by misuse, accidents,
                            improper handling, or external factors.
                          </li>
                          <li>
                            Charges Not Covered — Transportation, installation,
                            inspection, service charges, and any additional
                            expenses are not covered under warranty.
                          </li>
                          <li>
                            Product Instructions — The product must be used
                            according to the user manual and operating
                            instructions. Failure to follow the instructions
                            provided by Pixel Tools will void the warranty.
                          </li>
                          <li>
                            Correct Accessories — Only genuine accessories
                            recommended by Pixel Tools should be used. The use
                            of incorrect accessories will void the warranty.
                          </li>
                          <li>
                            Unauthorized Repairs — Repairs or servicing must be
                            carried out only by Pixel Tools authorized service
                            centers. Any third-party repair or service will void
                            the warranty.
                          </li>
                          <li>
                            Product Modifications — Any modification,
                            alteration, or tampering with the product is
                            strictly prohibited. Modified products are not
                            eligible for warranty claims.
                          </li>
                          <li>
                            Cosmetic & Non-Functional Damage — Cosmetic damages
                            such as scratches, dents, paint damage, or other
                            non-functional defects are not covered under
                            warranty. These damages do not affect the product's
                            functionality and are therefore excluded from
                            warranty coverage.
                          </li>
                          <li>
                            External Damage — Damage caused by fire, water,
                            dust, chemicals, misuse, negligence, or foreign
                            particles entering the machine is not covered under
                            warranty. Such damages are considered external
                            causes and are excluded from warranty coverage.
                          </li>
                          <li>
                            Mishandling & Misuse — Any damage caused due to
                            mishandling, negligence, abuse, or improper use of
                            the product will void the warranty. Customers are
                            advised to use the product responsibly and according
                            to the user manual.
                          </li>
                          <li>
                            Original Invoice Requirement — Warranty claims will
                            be accepted only upon submission of the original
                            purchase invoice. Duplicate, altered, or damaged
                            invoices may not be accepted for verification.
                          </li>
                          <li>
                            Claim Verification — The Pixel Tools Customer
                            Support Team may contact the customer up to two (2)
                            times to verify the warranty details. Customers are
                            requested to provide the required information and
                            documents promptly.
                          </li>
                          <li>
                            Warranty Approval — All warranty requests are
                            subject to inspection and approval by the Pixel
                            Tools Service Team. If the same issue occurs
                            repeatedly, a detailed inspection report may be
                            required before final warranty approval.
                          </li>
                        </ol>
                      </div>

                      <div style={{ textAlign: "right" }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => setShowTerms(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Submit Button */}
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-warranty-submit"
                    disabled={
                      submitting ||
                      !responseInvoiceFile ||
                      !responseProductFile ||
                      !acceptTerms
                    }
                  >
                    {submitting ? (
                      <span className="button-loading">
                        <span className="spinner-border spinner-border-sm"></span>
                        Submitting...
                      </span>
                    ) : (
                      "Submit Warranty Extension"
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>

      <app-footer></app-footer>

      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          onSuccess={() => {
            setShowAuthModal(false);
            // Re-submit will now have userId available
          }}
        />
      )}
    </>
  );
};

// Note: app-header and app-footer should be separate components or you can remove them
export default Warranty;
